
export const tabs = {
    tab_background_color:{
        backgroundColor:'#ffffff'
    },
    tab_indicator:{
        border: 'solid 2px #635ee7',
        height: 'calc(100% - 4px)',
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: 'transparent',
        maxWidth: 200,
        width: '100%',

    },
    tab_element:{
        textTransform: 'none',
        color: '#000000',
        marginRight: 8,
        '&:focus': {
          opacity: 1,
        },
    }

}


// WEBPACK FOOTER //
// ./src/components/CSS/tab.js